
export const locale = {
  'DIALOG' : {
    'DISPATCHER' : {
      'TITLE' : {
        'CREATE' : 'Create dispatcher',
        'EDIT' : 'Edit dispatcher',
      },
      'CONFIRMBUTTON' : {
        'CREATE' : 'Create',
        'SAVE' : 'Save',
      },
      'FULLNAME' : 'Full name',
      'CARRIER' : 'Carrier',
    },
    'ERROR' : {
      'ALREADYEXISTS' : 'Account already exists for this username.',
    }
  },
};
